import React, { useState, useEffect, useContext } from "react";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import CardWrap from "../Common/CardWrap";
import { shiftService } from "../../Services/shift.service";
import ResultModal from "../Common/ResultModal";
import { useTranslation } from "react-i18next";
import TimePicker from "react-bootstrap-time-picker";
import moment from "moment";
import Tooltip from "../Common/Tooltip";
import { GlobalContext } from "../../Contexts/GlobalContextProvider";

const initState = {
  storeId: -1,
  name: "",
  day: 0,
  from: null,
  to: null,
};

const ShiftUpdate = (props) => {
  const shiftId = props.match.params.shiftId;
  const storeId = props.match.params.storeId;
  const { t: translator } = useTranslation();
  const [isDisabled, setDisable] = useState(true);
  const [shift, setShift] = useState(initState);

  const [startFrom, setStartFrom] = useState(null);
  const [startTo, setStartTo] = useState(null);

  const { locName, locTenant, locStore } = useContext(GlobalContext);

  const [modal, setModal] = useState({
    title: "",
    text: "",
    show: false,
    btnClass: "",
    success: true,
  });

  const { register, handleSubmit, errors } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
  });
  const history = useHistory();

  useEffect(() => {
    shiftService
      .getById(shiftId)
      .then((res) => {
        setShift(res.data.data);
        setStartFrom(res.data.data.from);
        setStartTo(res.data.data.to);
      })
      .catch((err) => {
        console.error(err.response);
      });
  }, []);

  const onSubmit = () => {
    shiftService
      .update({
        shiftId: shiftId,
        name: shift.name,
        day: Number(shift.day),
        from:
          typeof shift.from === "number"
            ? moment.unix(shift.from).utc().format("H[:]m")
            : shift.from,
        to:
          typeof shift.to === "number"
            ? moment.unix(shift.to).utc().format("H[:]m")
            : shift.to,
      })
      .then((res) => {
        res.data.success
          ? setModal({
              show: true,
              title: translator("ShiftUpdate-SuccesModal-Title"),
              text: translator("ShiftUpdate-SuccesModal-Text"),
              btnClass: "btn btn-primary",
              success: true,
            })
          : setModal({
              show: true,
              title: translator("ShiftUpdate-UnsuccesModal-Title"),
              text: translator("ShiftUpdate-UnsuccesModal-Text"),
              btnClass: "btn btn-primary",
              success: false,
            });
      })
      .catch((err) =>
        setModal({
          show: true,
          title: translator("ShiftUpdate-UnsuccesModal-Title"),
          text: translator("ShiftUpdate-UnsuccesModal-Text"),
          btnClass: "btn btn-primary",
          success: false,
        })
      );
  };

  const handleInputChange = (event) => {
    setDisable(false);
    const { name, value } = event.target;
    setShift({ ...shift, [name]: value });
  };

  const handleTimeChangeFrom = (selectedTime) => {
    setShift({ ...shift, from: selectedTime });
    setDisable(false);
  };

  const handleTimeChangeTo = (selectedTime) => {
    setShift({ ...shift, to: selectedTime });
    setDisable(false);
  };

  const goBack = () => {
    let backedId = 0;
    switch (locName) {
      case "tenants":
        backedId = locTenant != 0 ? locTenant : "";
        break;
      case "stores":
        backedId = locStore != 0 ? locStore : "";
        break;
      default:
        history.push(`/stores/${storeId}`);
    }
    history.push(`/${locName}/${backedId}`);
  };

  const handleCancel = () => {
    history.push(`/stores/${storeId}`);
  };

  const handleClose = () => {
    setModal({ show: false });
    if (modal.success === true) {
      goBack();
    }
  };

  return (
    <CardWrap subtitle={translator("ShiftUpdate-Subtitle")}>
      <form onSubmit={handleSubmit(onSubmit)} className="row">
        <div className="col-lg-4">
          <fieldset className="scheduler-border">
            <legend className="scheduler-border">
              {translator("ShiftUpdate-GeneralData")}
            </legend>

            <div className="form-group">
              <label htmlFor="name">{translator("ShiftUpdate-Name")}</label>{" "}
              <Tooltip text={translator("Shift-Name-Msg")} />
              <input
                type="text"
                className="form-control"
                name="name"
                ref={register({ required: true, minLength: 30 })}
                value={shift.name}
                onChange={handleInputChange}
              />
              {errors.name && (
                <>
                  {errors.name.type === "required" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-RequiredField")}
                    </p>
                  )}
                  {errors.name.type === "maxLength" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-MaxLength30")}
                    </p>
                  )}
                </>
              )}
            </div>

            {/*  <div className="form-group">
              <label htmlFor="day">{translator("ShiftAdd-Day")}</label>
              <input
                type="text"
                className="form-control"
                name="day"
                ref={register({ required: true })}
                value={shift.day}
                onChange={handleInputChange}
              />
              {errors.day && (
                <>
                  {errors.day.type === "required" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-RequiredField")}
                    </p>
                  )}
                </>
              )}
                  </div> */}

            <div className="form-group">
              <label>{translator("ShiftUpdate-SubscriptionValid-From")}</label>{" "}
              <Tooltip text={translator("Shift-From-Msg")} />
              <TimePicker
                name="timePicker-from"
                start={startFrom !== null ? startFrom : "00:00"}
                end="24:00"
                step={15}
                onChange={handleTimeChangeFrom}
                value={shift.from}
              />
            </div>

            <div className="form-group">
              <label>{translator("ShiftUpdate-SubscriptionValid-To")}</label>{" "}
              <Tooltip text={translator("Shift-To-Msg")} />
              <TimePicker
                name="timePicker-to"
                start={startTo !== null ? startTo : "00:00"}
                end="24:00"
                step={15}
                onChange={handleTimeChangeTo}
                value={shift.to}
              />
            </div>
          </fieldset>
        </div>

        <div
          className="container-fluid"
          style={{
            display: "flex",
            paddingTop: "3%",
            justifyContent: "flex-end",
          }}
        >
          <button className="btn btn-outline-secondary" onClick={handleCancel}>
            {translator("Btn-Cancel")}
          </button>

          <button className="btn btn-primary" onClick={onSubmit}>
            {translator("Btn-Save")}
          </button>
        </div>
      </form>

      <ResultModal
        show={modal.show}
        title={modal.title}
        text={modal.text}
        btnClass={modal.btnClass}
        handleClose={handleClose}
      />
    </CardWrap>
  );
};

export default ShiftUpdate;
